export function commonLogic(): string {
  return 'common-logic';
}
